import { render, staticRenderFns } from "./JournalReport.vue?vue&type=template&id=708aca4e&scoped=true&"
import script from "./JournalReport.vue?vue&type=script&lang=js&"
export * from "./JournalReport.vue?vue&type=script&lang=js&"
import style0 from "./JournalReport.vue?vue&type=style&index=0&id=708aca4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708aca4e",
  null
  
)

export default component.exports